import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { QrCode, Loader2, AlertCircle } from "lucide-react";

export function QrImage({ className = "" }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let obj;
    let mounted = true;
    api
      .get("/user/qr", { responseType: "blob" })
      .then((r) => {
        if (!mounted) return;
        obj = URL.createObjectURL(r.data);
        setUrl(obj);
      })
      .catch(() => mounted && setErr(true));
    return () => {
      mounted = false;
      if (obj) URL.revokeObjectURL(obj);
    };
  }, []);

  if (err)
    return (
      <div className={`grid place-items-center rounded-xl border border-dashed border-slate-700 bg-slate-900/50 text-center p-6 ${className}`} data-testid="qr-empty">
        <AlertCircle className="h-8 w-8 text-slate-500 mb-2" />
        <p className="text-sm text-slate-400">No QR / UPI assigned yet.<br />Please contact support.</p>
      </div>
    );

  if (!url)
    return (
      <div className={`grid place-items-center rounded-xl bg-slate-900/50 ${className}`}>
        <Loader2 className="h-7 w-7 animate-spin text-emerald-400" />
      </div>
    );

  return (
    <div className={`grid place-items-center rounded-xl bg-white p-3 ${className}`} data-testid="qr-image-wrap">
      <img src={url} alt="Payment QR" className="h-full w-full object-contain rounded-md" data-testid="qr-image" />
    </div>
  );
}

export { QrCode };
